import React from 'react'
import { M_Table } from 'src/M_Components'

const equipmentType = () => {
  return (
    <M_Table entityName={'equipmentType'} />
  )
}

export default equipmentType